import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'

class PartnerInformationStore {

  @observable industries
  @observable partners
  @observable hasProvidedAllRequiredInformation
  @observable partnerInformationMissing
  @observable partnerContactInformationMissing
  @observable currentPartner

  @observable results
  @observable maxResults
  @observable orderby
  @observable searching
  @observable showFillInformationPopup

  constructor() {
    this.industries = []
    this.partners = {}
    this.hasProvidedAllRequiredInformation = false
    this.partnerInformationMissing = false
    this.partnerContactInformationMissing = false
    this.currentPartner = undefined

    this.results = undefined
    this.maxResults = undefined
    this.orderby = undefined
    this.searching = false
    this.showFillInformationPopup = true
    this.lastIndustry = undefined
  }

  @action setOrderby = (orderby) => {
    this.results = undefined
    this.orderby = orderby
  }

  @action hideInformationPopup = () => {
    this.showFillInformationPopup = false
  }

  @action setLastIndustry = (industry) => {
    this.lastIndustry = industry
  }

  onLogin = () => {
    this.loadIndustries()
    this.checkRequiredInformation()
  }

  loadIndustries = async () => {
    if(this.industries.length > 0) return

    (new Parse.Query("Industry")).each(async industry => {

      const count = await (new Parse.Query("Company")).contains("industries", industry.id).count()

      this.industries.push({ id: industry.id, name: industry.get("name"), image: industry.get("image"), text: industry.get("text"), slug: industry.get("slug"), count})
    })
  }

  search = async (section, query, industry) => {
    this.searching = true
    const res = await Parse.Cloud.run("searchPartners", { section, query, industry, orderby: this.orderby })
    await this.loadPartners(res.result)
    this.maxResults = res.total
    this.results = section === 0 ? res.result : [...this.results, ...res.result]
    this.searching = false
    return res
  }

  loadPartners = async ( id_list ) => {
    const promises = []

    for(const id of id_list) {
      if(!this.partners[id]) {
        promises.push(Parse.Cloud.run("getPartnerInformation", { objectId: id }))
      }
    }

    const res = await Promise.all(promises)

    for(const partner of res) {
      this.partners[partner.objectId] = partner
    }
  }

  loadPartnerFromShortname = async ( shortname ) => {
    let res = [...this.partners].find(partner => partner.shortname === shortname)

    if(!res) {
      try { res = await Parse.Cloud.run("getPartnerInformation", { shortname }) } catch (e) { }
      if(res) this.partners[res.objectId] = res
    }
    this.currentPartner = res
  }

  checkRequiredInformation = async () => {
    const result = await Parse.Cloud.run("hasProvidedRequiredUserInformation")
    this.hasProvidedAllRequiredInformation = result.hasRequired
    this.partnerInformationMissing = result.partnerInformationMissing
    this.partnerContactInformationMissing = result.partnerContactInformationMissing

  }

  getFromId = ( id ) => {
    return this.partners[id]
  }

  getIndustryFromId = ( id ) => {
    return this.industries.find(elem => elem.id === id)
  }

  getIndustryFromSlug = ( slug ) => {
    return this.industries.find(elem => elem.slug === slug)
  }

  getFromShortname = ( shortname ) => {
    let res = [...this.partners].find(partner => partner.shortname === shortname)
    if(!res) this.loadPartnerFromShortname( shortname )
    return res
  }

  getLastIndustry = () => {
    return this.lastIndustry
  }
}

const store = new PartnerInformationStore()
export default store



// WEBPACK FOOTER //
// /src/stores/PartnerInformationStore.js